<template>
  <img :class="isSquared ? '' : 'is-rounded'" :src="dna | asAvatar" alt="" />
</template>

<script>
export default {
  name: "AvatarImg",

  props: ["player", "isSquared"],

  computed: {
    dna() {
      if (!this.player) return null;
      if (this.player.aiLevel) return "bot";
      return this.player.dna;
    },
  },
};
</script>

<style></style>
